export const updateRejectedAction = (actions) => {
    return (dispatch, getState) => {
        dispatch({ type: 'UPLOAD_REJECTION_UPDATE', actions })
    }
}
